
import { ReactNode, memo } from "react";
import { cn } from "@/lib/utils";

type DangerCardProps = {
  title: ReactNode;
  description?: ReactNode;
  action: ReactNode;
  className?: string;
  children?: ReactNode;
};

export const DangerCard = memo(function DangerCard({
  title,
  description,
  action,
  className,
  children,
}: DangerCardProps) {
  return (
    <div
      className={cn(
        "space-y-3 border border-red-200 rounded-lg p-4 bg-red-50/50",
        className
      )}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1">
          <p className="text-sm font-medium text-red-700">{title}</p>
          {description ? (
            <p className="text-xs text-red-600/90">{description}</p>
          ) : null}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
});
